import { App } from '@capacitor/app'
import type { URLOpenListenerEvent } from '@capacitor/app'
import { StatusBar, Style } from '@capacitor/status-bar'
import { FirebaseDynamicLinks } from '@pantrist/capacitor-firebase-dynamic-links'
import { Browser } from '@capacitor/browser'

const isLoaded = ref(false)

export default defineNuxtPlugin(async (nuxtApp) => {
  const { isIOS } = useDevice()
  try {
    if (!useDetect().isApp) {
      return
    }

    nuxtApp.hooks.hookOnce('page:finish', () => {
      isLoaded.value = true
    })

    await StatusBar.setStyle({ style: Style.Light })
    useDevice().platform === 'android' &&
      (await StatusBar.setBackgroundColor({ color: '#ffffff' }))

    const router = useRouter()
    App.addListener('backButton', () => {
      if (router) {
        router.go(-1)
      }
    })

    async function onAppUrlOpen(event: URLOpenListenerEvent) {
      const deepLinkPrefix = 'app-link'
      try {
        await Browser.close()
      } catch (error: any) {
        console.log('Error on browser close on appUrlOpen', error)
      }
      let path = event.url.includes('wnhub.io') && event.url.split('.io').pop()
      console.log('app: on appUrlOpen', path, event.url)

      if (path && path.includes(deepLinkPrefix)) {
        path = path.split(deepLinkPrefix).pop()
        console.log('app: remove deep link prefix', path)
      }

      if (path && path.startsWith('/events/')) {
        window.open(`/eventhub/index.html?redirect=${path}`, '_self')
        return
      }

      if (path) {
        if (isLoaded.value) {
          await router.replace(path)
        } else {
          // for some reason on some devices onNuxtReady doesn't work, we also getting two page:finish events
          // TODO: research this issue in details
          nuxtApp.hooks.hookOnce('page:finish', async () => {
            await router.replace(path)
          })
        }
      }
    }

    App.addListener('appUrlOpen', onAppUrlOpen)

    function listenToDeepLinkOpen() {
      FirebaseDynamicLinks.addListener('deepLinkOpen', async (data) => {
        // on IOS we will get double callbacks: native and firebase
        if (!isIOS) {
          console.log('on deepLinkOpen', JSON.stringify(data))
          await onAppUrlOpen(data)
        }
      })
    }

    listenToDeepLinkOpen()

    usePushService().addListeners()
    await usePushService().registerNotifications()
  } catch (e: any) {
    useLogError(e)
  }
})
